// extracted by mini-css-extract-plugin
module.exports = {"container":"AsSeenIn_container__10jJg","img":"AsSeenIn_img__48LDT"};